
const portes = [
  {
    'id': 6,
    'nome': 'Pequena (Indústria: 20-99 empregados | Comércio: 10-49 empregados)'
  },
  {
    'id': 7,
    'nome': 'Média (Indústria: 100-499 empregados | Comércio: 50-99 empregados)'
  },
  {
    'id': 8,
    'nome': 'Grande (Indústria: 500 ou mais empregados | Comércio: 100 ou mais empregados)'
  }
]

export default portes



// WEBPACK FOOTER //
// ./src/vuex/cache/portes.js